import useTranslation from "next-translate/useTranslation";
import Image from "next/image";
import styles from "../events/PublicDetail.module.scss";
import UserImage from "../shared/user_image";
import QrCode from "qrcode.react";
import { capitalize } from "../../helpers/application";
import AvatarList from "../groups/avatar_list";
import AboutContent from "./about_content";

const PublicDetail = ({ group, refetch }) => {
  const { t } = useTranslation("common");
  const canvasId = "qr-gen";
  const groupPath = `/groups/${group.token}`;
  const groupURL = `${process.env.NEXT_PUBLIC_APP_URL}${groupPath}`;
  const tz = "Europe/Prague";

  const signInLink = `/sign_in?redirectTo=${groupPath}`;

  return (
    <div className={`container mb-5`}>
      <div className="ms-1 me-1">
        <div className="mt-3 mb-3">
          <div className="d-flex">
            <Image src="/images/logo-black.svg" width={200} height={40} alt="Logo unalanu" layout="raw" />
            <div className="m-auto" />
            <a className="float-end me-1 mt-1 align-self-center" href={signInLink}>
              {t("common:profile.sign_in").toUpperCase()}
            </a>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className={styles.cardbox}>
            <div
              className={`${styles.topbar} cover-image header-images header-images-content`}
              style={{
                backgroundImage: group.cover_image?.url
                  ? `url(${group.cover_image.url.replace("http://unite-api-host", "http://localhost")})`
                  : `url("/images/bg-sport.png")`,
              }}
            >
              <div>
                <img
                  src={group.logo_thumb.replace(process.env.NEXT_PUBLIC_API_URL, process.env.NEXT_PUBLIC_API_LOCAL_URL)}
                  style={{
                    height: "100%",
                    width: "auto",
                    maxHeight: "140px",
                    maxWidth: "140px",
                    borderRadius: "360px",
                    position: "absolute",
                    right: "5%",
                    bottom: "-3rem",
                    border: "5px solid white",
                    borderRadius: "360px",
                  }}
                />
                {/* <UserImage src={group.logo_thumb} name={group.name} width="100%" height="100%" /> */}
              </div>
            </div>

            <div className="p-3">
              <h1 className={styles.h1}>{group.name}</h1>
              <div className="row mt-4">
                <div className="col-md-6 mb-1">
                  <div className="d-flex">
                    <AvatarList
                      users={group.members}
                      showMoreLink={false}
                      totalCount={group.approved_members_count}
                      membersListLink={null}
                      profilesLink={false}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <div className="row">
            <div className="col-md-12">
              <div className={`${styles.cardbox} mt-4 p-3`}>
                <h1>{`${capitalize(t("about"))} ${t("groups.one").toLowerCase()}`}</h1>
                <div className="">
                  <AboutContent group={group} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="row">
            <div className="col-md-12">
              <div className={`${styles.cardbox} mt-4 p-3`}>
                <h1>{t("public:groups.become_member")}</h1>
                <div className="d-flex">
                  <div className="row justify-content-between align-items-center mt-3">
                    <div className="col-12 mb-3">
                      {t("public:groups.join1", { group: group.name })} <strong> unalanu </strong>{" "}
                      {t("public:groups.join2")}
                    </div>
                    <div className="col-6 text-center">
                      <a
                        href="https://play.google.com/store/apps/details?id=com.railsformers.unalanu"
                        rel="nofollow"
                        title="Google Play"
                      >
                        <Image
                          src="/images/google-play-badge.png"
                          width={190}
                          height={58}
                          alt="Google Play store badge"
                          layout="raw"
                          style={{ width: "100%", height: "auto" }}
                        />
                      </a>
                    </div>
                    <div className="col-6 text-center">
                      <a href="https://apps.apple.com/us/app/unalanu/id1642908664" rel="nofollow" title="App Store">
                        <Image
                          src="/images/app-store-badge.png"
                          width={180}
                          height={60}
                          alt="App Store badge"
                          layout="raw"
                          style={{ width: "100%", height: "auto" }}
                        />
                      </a>
                    </div>
                  </div>
                </div>

                <div className="mt-3">{t("public:join_text2")}</div>
                <div className="mt-3 text-center">
                  <QrCode value={groupURL} id={canvasId} />

                  <div className="small">
                    <a className="mt-1" href={groupURL} target="_blank" rel="noreferrer">
                      {t("public:open_in_app").toUpperCase()}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicDetail;
